import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * Realtime state written by the `store.{tenantId}` business-event listeners
 * (see hooks/useStoreRealtimeRefresh).
 *
 * Every field here has BOTH a writer and a reader — the previous shape carried
 * 13 fields, of which a dozen were written only by listeners that were never
 * registered (or never read at all), so they sat permanently at their initial
 * values while looking authoritative. `connected` in particular was read by
 * AdminLayout to render an online/offline dot, but this slice is not persisted
 * and is written only by listeners that run on the dashboard route — the admin
 * layout therefore always rendered "offline". Connection state now comes from
 * useEcho/useRealtimeConnected, which polls the socket itself.
 */
interface StockWebSocketState {
  lastLowStockAlert: any | null;
  lastSaleCreated: any | null;
  stockUpdateHistory: any[];
}

const initialState: StockWebSocketState = {
  lastLowStockAlert: null,
  lastSaleCreated: null,
  stockUpdateHistory: [],
};

const stockWebSocketSlice = createSlice({
  name: 'stockWebSocket',
  initialState,
  reducers: {
    updateLastStock(state, action: PayloadAction<any>) {
      state.stockUpdateHistory.unshift(action.payload);
      if (state.stockUpdateHistory.length > 50) {
        state.stockUpdateHistory = state.stockUpdateHistory.slice(0, 50);
      }
    },
    updateLastLowStockAlert(state, action: PayloadAction<any>) {
      state.lastLowStockAlert = { ...action.payload, _t: Date.now() };
    },
    updateLastSaleCreated(state, action: PayloadAction<any>) {
      state.lastSaleCreated = { ...action.payload, _t: Date.now() };
    },
  },
});

export const {
  updateLastStock,
  updateLastLowStockAlert,
  updateLastSaleCreated,
} = stockWebSocketSlice.actions;

export default stockWebSocketSlice.reducer;
